import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  listSurveys: {
    method: 'GET',
    url: `${configs.baseUrl}/api/survey`,
  },
  createSurvey: {
    method: 'POST',
    url: `${configs.baseUrl}/api/survey`,
  },
  patchSurvey: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/survey/{surveyId}`,
  }
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const listSurveys = async () => {
  const res = await resource.listSurveys()
  return res.body.surveys
}

const createSurvey = async (params) => {
  const res = await resource.createSurvey(params)
  return res.body
}

const patchSurvey = async (surveyId, params) => {
  const res = await resource.patchSurvey({surveyId}, params)
  return res.body.survey
}

export default {
  initResource,
  listSurveys,
  createSurvey,
  patchSurvey,
}
